import { EMAIL_MESSAGE, MAX_LENGTH_MESSAGE, REQUIRED_MESSAGE } from '@Const/error-messages'
import { FormDiscriminatedProps } from '@App/forms/common/form-field'
import { EMAIL_REGEX } from '@Const/regexp'
import { isNotAnReservedEmail } from '@App/helpers/validate'
import { FormFieldTypes } from '@App/enum/form-field-types'

export const FIRST_NAME_LABEL = 'First Name'
export const LAST_NAME_LABEL = 'Last Name'
export const EMAIL_LABEL = 'Email Address'

export const PASSWORD_LABEL = 'Password'

export const STANDARD_FIRST_NAME: FormDiscriminatedProps = {
    name: 'firstName',
    label: FIRST_NAME_LABEL,
    type: FormFieldTypes.TEXT,
    registerOptions: {
        required: REQUIRED_MESSAGE,
        maxLength: {
            value: 60,
            message: `${MAX_LENGTH_MESSAGE} 60`,
        },
    },
}

export const STANDARD_LAST_NAME: FormDiscriminatedProps = {
    name: 'lastName',
    label: LAST_NAME_LABEL,
    type: FormFieldTypes.TEXT,
    registerOptions: {
        required: REQUIRED_MESSAGE,
        maxLength: {
            value: 60,
            message: `${MAX_LENGTH_MESSAGE} 60`,
        },
    },
}

export const OPTIONAL_LAST_NAME: FormDiscriminatedProps = {
    name: 'lastName',
    label: LAST_NAME_LABEL,
    type: FormFieldTypes.TEXT,
    registerOptions: {
        maxLength: {
            value: 60,
            message: `${MAX_LENGTH_MESSAGE} 60`,
        },
    },
}

export const STANDARD_EMAIL: FormDiscriminatedProps = {
    name: 'email',
    label: EMAIL_LABEL,
    type: FormFieldTypes.TEXT,
    registerOptions: {
        required: REQUIRED_MESSAGE,
        pattern: {
            value: EMAIL_REGEX,
            message: EMAIL_MESSAGE,
        },
        maxLength: {
            value: 2000,
            message: `${MAX_LENGTH_MESSAGE} 2000`,
        },
        validate: isNotAnReservedEmail,
    },
}
